import { FC } from "react"
import { UserbotPage } from "./userbotPage"
import { ChainsTable } from "../components/chains/chainsTable"

export const ChainsPage: FC = () => (
  <UserbotPage title="Цепочки">
    <ChainsTable />
  </UserbotPage>
)
